// extracted by mini-css-extract-plugin
export default {"spinner":"LpSpinner_spinner__xGl1P","loaderMessage":"LpSpinner_loaderMessage__O0oBA"};